import { createChannelSchema } from '../../../schema/create-channel.schema';
import { SubmitForm } from '../../../utils/submit-form.util';
import Button from '../../button/v2/button';
import Container from '../../containers/container';
import { HStack, VStack } from '../../layouts/stack.layout';
import HForm from '../form';
import SelectFormGroup from '../inputs/select.formGroup';
import TextFormGroup from '../inputs/text.formGroup';

type CreateChannelFormType = {
  name: string;
  description: string;
  tags: string[];
  isPrivate: boolean;
};

export default function CreateChannelForm() {
  const initialValues = {
    name: '',
    description: '',
    tags: [],
    isPrivate: false,
  };
  return (
    <HForm<CreateChannelFormType>
      className="relative"
      initialValues={initialValues}
      validationSchema={createChannelSchema}
      onSubmit={(values: any, setSubmitting: Function) =>
        SubmitForm.createChannelForm(values, setSubmitting)
      }
    >
      <HStack extensions="relative w-full" justify="center">
        <Container extensions="w-[150px] h-[150px] bg-black rounded-lg relative">
          <Container extensions="absolute bg-white/10 rounded-lg left-0 top-0 bottom-0 right-0" />
        </Container>

        <Container extensions="absolute top-1/2 left-1/2 translate-y-[-50%] translate-x-[-50%]">
          <Button color="glass" asIcon="image" size="lg" withButtonStyle />
        </Container>
      </HStack>
      <Container extensions="w-full px-5 mt-7">
        <VStack gap="base">
          <TextFormGroup name="name" type="text" label="name" />
          <TextFormGroup
            name="description"
            label="description"
            type="textarea"
            maxLength={150}
            rows={3}
          />
          <TextFormGroup name="tags" type="text" label="tags" />
          <SelectFormGroup name="isPrivate" label="Accessibility">
            <option value="private">Private</option>
            <option value="public">Public</option>
          </SelectFormGroup>
        </VStack>
      </Container>
    </HForm>
  );
}
